//* Libraries imports
import { useState, useCallback } from "react";

//* Service imports
import { templateHistoryService } from "@/features/template/TemplateHistoryService";

//* Types imports
import type { ApiError } from "@/types/api";
import type {
  ITemplateHistory,
  TemplateHistoryFilters,
} from "@/features/template/types";

export const useFetchTemplateHistory = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [items, setItems] = useState<ITemplateHistory[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [item, setItem] = useState<ITemplateHistory | null>(null);

  const fetchAll = useCallback(async (filters: TemplateHistoryFilters = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await templateHistoryService.list(filters);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response && response.data) {
        setItems(response.data || []);
        setTotal(response.data.total || 0);
        return response.data;
      }
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao buscar o histórico do template";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchById = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await templateHistoryService.fetchById(id);

      if ("code" in response && "message" in response) {
        const apiError = response as ApiError;
        throw new Error(apiError.message);
      }

      if ("data" in response) {
        setItem(response.data || null);
        return response.data;
      }
    } catch (err: any) {
      const errorMessage =
        err.message || "Ocorreu um erro ao buscar o detalhe do histórico";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return { fetchAll, fetchById, items, total, item, loading, error };
};
